import { memo } from "react";

type NotificationBadgeProps = {
  count: number
  animate?: boolean
};

export const NotificationBadge = memo(({ count, animate = false }: NotificationBadgeProps) => {
  if (count <= 0) return null;

  const displayCount = count > 99 ? "99+" : count;

  return (
    <span
      className={`relative z-10 flex justify-center items-center min-w-5 h-5 px-1 rounded-full text-white bg-orange-400 text-xs font-medium ${animate ? "animate-pulse" : ""}`}
    >
      {animate && <span className="absolute inset-0 rounded-full bg-red-400 opacity-75" />}
      <span className="z-10">{displayCount}</span>
    </span>
  );
});

NotificationBadge.displayName = "NotificationBadge";
